// SET_CONFIG_DB
// SET_IS_STORE_OPEN

export default {

  SET_CONFIG_DB(state, value) {
    state.ConfigDB = value;
  },

  SET_IS_STORE_OPEN(state, value) {
    state.ConfigDB.isStoreOpen = value;
  },

}
